export enum PositionTitles {
  'CNA/PCT' = 'CNA/PCT',
  'CT Technologist' = 'CT',
  'Dialysis Tech' = 'Dialysis Tech',
  'ED Tech' = 'ED Tech',
  'EEG Tech' = 'EEG Tech',
  'Interventional Radiology Technologist' = 'IR Tech',
  Laboratory = 'Laboratory',
  'Licensed Practical/Vocational Nurse (LPN/LVN)' = 'LPN/LVN',
  'Monitor Tech' = 'Monitor Tech',
  'MRI Technologist' = 'MRI',
  'Nuclear Medicine Technologist' = 'Nuclear Medicine',
  'Nurse Practitioner (NP)' = 'NP',
  'Occupational Therapist (OT)' = 'OT',
  'Paramedic/EMS' = 'Paramedic/EMS',
  Pharmacy = 'Pharmacy',
  Phlebotomist = 'Phlebotomist',
  'Physical Therapist (PT)' = 'PT',
  'Physical Therapy Assistant' = 'Physical Therapy Assistant',
  'Physician Assistant (PA)' = 'PA',
  'Radiation Therapist' = 'Radiation Therapist',
  'Radiologic Technologist (X-ray)' = 'X-ray',
  'Registered Dietitian' = 'Registered Dietitian',
  'Registered Nurse (RN)' = 'RN',
  'Respiratory Therapist (RT)' = 'RT',
  'Social Work' = 'Social Work',
  'Speech-Language Pathologist (SLP)' = 'SLP',
  'Sterile Processing' = 'Sterile Processing',
  'Surgical Technologist' = 'Surgical Tech',
  Transport = 'Transport',
  'Ultrasound / Sonographer' = 'Ultrasound',
}

export const LEGACY_POSITION_ALIASES: Record<string, string> = {
  'Registered Dietician': 'Registered Dietitian',
}

export const normalizePositionTitle = (value: string): string =>
  LEGACY_POSITION_ALIASES[value?.trim()] ?? value?.trim() ?? ''
